/**
 * 平台检测工具
 * 用于区分企业微信原生环境与橘子侧边栏环境
 */

/**
 * 判断当前是否在橘子平台侧边栏中
 * juzi-helper 会覆写 window.wx 并设置 wx.isJuziWx = true
 */
export function isJuzi() {
  // console.log('句子判断');
  // console.log(window.wx.isJuziWx);
  return typeof window !== 'undefined' && window.wx && window.wx.isJuziWx === true;
}

/**
 * 获取当前可用的 wx 对象
 * 企业微信环境返回 window.jWeixin，橘子环境返回被覆写后的 window.wx
 */
export function getWx() {
  if (isJuzi()) {
    return window.wx;
  }
  return window.jWeixin || window.wx;
}

/**
 * 校验并确保当前企业微信成员 userId 包含在拉群参数的 userIds 中
 * userIds 约定以分号分隔（如 "userA;userB"）
 * - 未传入 userIds：直接用当前用户 userId 赋值
 * - 已传入 userIds：匹配当前用户是否已存在，不存在则追加，存在则不重复添加
 * @param {Object} joinGroupParams 拉群参数对象，会对 userIds 字段做就地修改
 * @param {string} currentUserId 当前登录用户的企业微信 userId
 */
export function ensureCurrentUserInUserIds(joinGroupParams, currentUserId) {
  // 当前用户 userId 为空时无需处理
  if (!currentUserId) {
    return;
  }

  const passedUserIds = joinGroupParams?.userIds;

  // 未传入 userIds：直接赋值为当前用户
  if (passedUserIds === undefined || passedUserIds === null || passedUserIds === '') {
    joinGroupParams.userIds = currentUserId;
    return;
  }

  // 统一转为字符串并按分号拆分，过滤空串后比较
  const userIdList = String(passedUserIds)
    .split(';')
    .map((item) => item.trim())
    .filter((item) => item !== '');

  const isAlreadyIncluded = userIdList.some((userId) => userId === currentUserId);

  // 已包含则不重复添加，未包含则追加
  if (!isAlreadyIncluded) {
    userIdList.push(currentUserId);
    joinGroupParams.userIds = userIdList.join(';');
  }
}

